import Offer_Section from "./Offer_Section";
import Portal_Section_3 from "./Portal_Section_3";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import TestimonialSection from "../HomePage/TestimonialSection/TestimonialSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { Helmet } from "react-helmet";

const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const Offer_Image = `${digitalOceanURL}/Portal_Image/Offer_Portal_Image.png`;
const Offer_Small_Image = `${digitalOceanURL}/Portal_Image/Offer_Portal_Small_Img.png`;

const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://hirestar.io/offer-portal#software",
      name: "HireStar.io Offer Portal",
      operatingSystem: "Web",
      applicationCategory: "BusinessApplication",
      description:
        "HireStar.io's Offer Portal streamlines the offer letter generation process, integrating blockchain technology to ensure secure and transparent hiring practices.",
      url: "https://hirestar.io/offer-portal",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://hirestar.io/offer-portal",
      url: "https://hirestar.io/offer-portal",
      name: "HireStar.io Offer Portal",
      description:
        "Access HireStar.io's Offer Portal to generate offer letters efficiently and securely, leveraging blockchain technology for transparent hiring processes.",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "Organization",
      "@id": "https://hirestar.io/#organization",
      name: "HireStar.io",
      url: "https://hirestar.io",
      logo: {
        "@type": "ImageObject",
        url: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
      },
      sameAs: [
        "https://in.linkedin.com/showcase/hirestar.io/",
        "https://www.facebook.com/hirestario",
        "https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09",
        "https://www.instagram.com/hirestar.io/",
      ],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Offer Portal",
          item: "https://hirestar.io/offer-portal",
        },
      ],
    },
  ],
};

export default function Offer_Portal() {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Streamline Your Hiring with the Offer Experience Portal | Hirestar.io
        </title>
        <meta
          name="description"
          content="Reinvent your hiring process with Hirestar.io’s Offer Experience Portal. Enhance efficiency, transparency, and candidate experience through a modern, digital recruitment solution."
        />
        <meta
          name="keywords"
          content="offer experience portal, streamline hiring process, digital recruitment solution, candidate experience, modern hiring tools, HR workflow automation, Hirestar.io, recruitment efficiency, hiring transparency, HR innovation"
        />

        <meta
          property="og:title"
          content="Streamline Your Hiring with the Offer Experience Portal | Hirestar.io"
        />
        <meta
          property="og:description"
          content="Reinvent your hiring process with Hirestar.io’s Offer Experience Portal. Enhance efficiency, transparency, and candidate experience through a modern, digital recruitment solution."
        />
        <meta property="og:url" content="https://hirestar.io/offer-portal" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/Offer_Portal_Image.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:site_name" content="Hirestar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Streamline Your Hiring with the Offer Experience Portal | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Reinvent your hiring process with Hirestar.io’s Offer Experience Portal. Enhance efficiency, transparency, and candidate experience through a modern, digital recruitment solution."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/Offer_Portal_Image.png"
        />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div className="relative blog_bg_image mb-24 lg:mb-0 background_color">
        {/* ---------------------------show this for lg and md device------------------------------------- */}
        <div className="lg:relative lg:top-12 flex flex-col lg:mx-12 top_image_gap1">
          <div className=" flex flex-col lg:relative  lg:right-10 leading-tight z-[2] portal-box ">
            <div className="p-2 mt-4  lg:ml-16">
              <div className="text-wrap text-[32px] md:text-[46px] lg:text-[46px] mt-14 lg:mt-0 md:mt-20   font-semibold font-[poppins] text-center ">
                {/* <h1 className="text-[32px] md:text-[46px] lg:text-[46px]" aria-label="Introducing the Hirestar.io Offer Portal">
                  Introducing the Hirestar.io
                  <span className="text-[#1783C4]"> Offer Portal</span>
                </h1> */}
                {/* updated heading */}
                <h1
                  className="inline"
                  aria-label="Introducing the Hirestar.io Offer Portal"
                >
                  Introducing The Hirestar.io{" "}
                </h1>
                <span
                  className="inline text-[#1783C4] "
                  aria-label="Hirestar.io Offer Portal"
                >
                  Offer Portal
                </span>
                {/* -------------------------- */}
              </div>
              <div className="text-wrap px-2 lg:px-0 md:px-0  font-[poppins] font-[16px] mt-4 md:mt-6 lg:mt-6 text-center paragraph">
                <p>
                  Streamline hiring with secure, blockchain-based background
                  checks <br className="hidden md:block lg:block " />
                  Trust Hirestar.io for verified and transparent employee
                  screening
                </p>
              </div>
            </div>

            {/* --------------------------buttons-------------------- */}
            <ButtonComponent
              arialLabel={
                "Get in touch with an expert to know more about Hirestar.io Offer Portal"
              }
            />
          </div>

          <div className="large-image">
            {/* Home Image */}
            <img
              className="home-image sm:mb-12 lg:relative w-full image_gap"
              alt="hero img offer portal service"
              src={Offer_Image}
              title="offer portal service img"
              loading="lazy"
            />
          </div>

          {/* -------------------------show this for small device-------------------------------------- */}
          <div className="relative w-full max-w-sm mx-auto small-image">
            <div className="overflow-hidden rounded-lg">
              <div className="flex transition-transform duration-300 ease-in-out mb-20">
                <img
                  src={Offer_Small_Image}
                  alt="offer portal small screen img"
                  title="offer portal hero img for small screen"
                  className="w-full h-auto flex-shrink-0"
                />
              </div>
            </div>
          </div>

          {/* ------------------------dot code to show  current image -------------------- */}
        </div>
      </div>
      <div className="mt-20 lg:mb-0  mb-16 ">
        <BrandCarousel />
      </div>
      <Offer_Section />
      <Portal_Section_3
        heading="Offer Portal"
        Paragraph="Streamline hiring by tackling moonlighting, offer shopping, and late joining. Ensure a smooth transition from offer to onboarding."
        section="Offer_Portal"
      />
      <BgvStepsSection />
      <div>
        <TestimonialSection />
      </div>

      <FaqComponent />

      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
